<div
    *ngIf="mention"
    class="agpr-socialPostDetails"
>
    <!-- Post Details -->
    @if (
        mention.createdByUserId ||
        mention.createdDate ||
        mention.lastModifiedByUserId ||
        mention.lastModifiedDate ||
        mention.mentionId ||
        mention.folderIds?.length
    ) {
        <agpr-panel
            header="Social.post.viewer.postDetails"
            [marginTop]="0"
        >
            @if (mention.createdByUserId) {
                <section class="agpr-socialPostDetails-section">
                    <div class="agpr-socialPostDetails-label">{{ 'Social.post.viewer.saveBy' | localize }}</div>
                    <div class="agpr-socialPostDetails-value">{{ usersMap[mention.createdByUserId] }}</div>
                </section>
            }

            @if (mention.createdDate) {
                <section class="agpr-socialPostDetails-section">
                    <div class="agpr-socialPostDetails-label">{{ 'Social.post.viewer.savedDate' | localize }}</div>
                    <div class="agpr-socialPostDetails-value">{{ mention.createdDate | changeTimeZone: preferences.timeZone: 'MMMM D, YYYY H:mm z' }}</div>
                </section>
            }

            @if (mention.lastModifiedByUserId) {
                <section class="agpr-socialPostDetails-section">
                    <div class="agpr-socialPostDetails-label">{{ 'Social.post.viewer.modifiedBy' | localize }}</div>
                    <div class="agpr-socialPostDetails-value">{{ usersMap[mention.lastModifiedByUserId] }}</div>
                </section>
            }

            @if (mention.lastModifiedDate) {
                <section class="agpr-socialPostDetails-section">
                    <div class="agpr-socialPostDetails-label">{{ 'Social.post.viewer.modifiedDate' | localize }}</div>
                    <div class="agpr-socialPostDetails-value">{{ mention.lastModifiedDate | changeTimeZone: preferences.timeZone: 'MMMM D, YYYY H:mm z' }}</div>
                </section>
            }

            @if (mention.mentionId) {
                <agpr-tags-picker
                    [style]="agprComponentStyleEnum.social"
                    [(ngModel)]="mention.tagIds"
                    (ngModelChange)="tagsUpdated($event)"
                ></agpr-tags-picker>
            }

            @if (mention.folderIds?.length) {
                <agpr-social-post-folders
                    [mention]="mention"
                ></agpr-social-post-folders>
            }
        </agpr-panel>
    }



    <!-- Post Information -->
    <agpr-panel
        header="Social.post.viewer.postInformation"
        [marginTop]="0"
    >
        <div class="agpr-socialPostDetails-metadataWrapper">
            @for (attribute of postInformationBadges; track attribute.label) {
                <agpr-meta-data
                    class="agpr-socialPostDetails-metadata"
                    [type]="attribute.type"
                    [mediaType]="attribute.mediaType"
                    [icon]="attribute.icon"
                    [value]="attribute.value"
                    [tooltip]="attribute.label"
                ></agpr-meta-data>
            }
        </div>
    </agpr-panel>

    <!-- Engagement -->
    @if (mention?.mediaType.id !== mediaTypeEnum.REDDIT) {
        <agpr-panel
            header="Social.post.viewer.engagement"
            [marginTop]="0"
            [tooltip]="('Social.postFeed.lastUpdate' | localize) + (mention?.lastModifiedDate ? (mention?.lastModifiedDate | changeTimeZone: preferences.timeZone: 'MMMM D, YYYY H:mm z') : 'N/A')"
        >
            @if (mention?.tweetData?.type !== tweetTypeEnum.RETWEET) {
                <div class="agpr-socialPostDetails-metadataWrapper">
                    @for (attribute of engagementBadges; track attribute.label) {
                        @if (attribute.type === attributeTypesEnum.percent) {
                            <agpr-meta-data
                                class="agpr-socialPostDetails-metadata"
                                [type]="attribute.type"
                                [icon]="attribute.icon"
                                [value]="(attribute.value || attribute.value === 0)
                                    ? (attribute.value | number: '1.0-2')
                                    : null"
                                [tooltip]="attribute.label"
                            ></agpr-meta-data>
                        } @else {
                            <agpr-meta-data
                                class="agpr-socialPostDetails-metadata"
                                [type]="attribute.type"
                                [icon]="attribute.icon"
                                [value]="(attribute.value || attribute.value === 0)
                                    ? (attribute.value | number)
                                    : null"
                                [tooltip]="attribute.label"
                            ></agpr-meta-data>
                        }
                    }
                </div>
            } @else {
                <section class="agpr-socialPostDetails-section">
                    <div class="agpr-socialPostDetails-noEngagement">{{ 'Social.post.viewer.engagement.notAvailable' | localize }}</div>
                </section>
            }
        </agpr-panel>
    }


    <!-- Post Sharing -->
    <agpr-panel
        header="Social.post.viewer.postSharing"
        [marginTop]="0"
    >
        @if (mention.shareable) {
            <agpr-content-sharing
                [id]="'socialPostDetails.selectedMention'"
                [content]="mention.sharingInformation"
                class="agpr-mentionDetails-contentSharing"
            ></agpr-content-sharing>
        }
    </agpr-panel>

    <!-- Post -->
    <agpr-panel
        header="Social.post.viewer.post"
    >
        <agpr-social-post-article
            [mention]="mention"
        ></agpr-social-post-article>

        <agpr-original-tweet
            [tweetData]="mention.tweetData"
            class="agpr-socialPostDetails-originalTweet"
        ></agpr-original-tweet>
    </agpr-panel>
</div>
